import {
	Directive,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	OnInit,
	Output,
} from '@angular/core';

enum TextPointer {
	InstrumentText = 'instrumentText',
	RequisitionText = 'requisitionText',
}
@Directive({
	selector: '[requisitionTagTextValidation]',
	standalone: false,
})
export class RequisitionTagTextValidationDirective
	implements OnInit, OnChanges
{
	@Input() instrumentText: string;
	@Input() requisitionText: string;
	@Input() set requisitionTagTextValidation(fieldName: string) {
		this.regexPattern = new RegExp(
			`{{\\s*?(requisitions.id.fields.${fieldName}(?:\\.\\w+)*)\\s*?}}`,
		);
		this.fieldName = fieldName;
	}
	@Output() instrumentTextChange = new EventEmitter<string>();
	@Output() requisitionTextChange = new EventEmitter<string>();
	public regexPattern: RegExp;
	public fieldName: string;
	/**
	 * Find the initial tag in the requisitionTagTextValidation (eg. instruction text = {{requisitions.id.fields.value?.formatted}})
	 * If it is found in the text then this is the tag to check for otherwise just the simple text tag {{requisitions.id.fields.value}}
	 */
	public initTag: string;
	public get tag() {
		return this.initTag ?? `{{ requisitions.id.fields.${this.fieldName} }}`;
	}
	public textPointer: TextPointer = TextPointer.InstrumentText;
	constructor(private el: ElementRef) {}

	ngOnInit(): void {
		for (const text of [
			TextPointer.InstrumentText,
			TextPointer.RequisitionText,
		]) {
			const initTag = this[text].match(this.regexPattern)?.at(1);
			if (initTag) {
				// Change it to the absolute tag with spaces on either side of between tag and brackets
				this.initTag = `{{ ${initTag} }}`;
				this.regexPattern = new RegExp(this.initTag.replace(/\s/g, '\\s*?'));
				this.textPointer = text;
				break;
			}
		}

		this.setChecked();
	}

	ngOnChanges() {
		this.setChecked();
	}

	@HostListener('click', ['$event']) onClick(event: MouseEvent) {
		if (this.isChecked()) {
			event.preventDefault();
			event.stopPropagation();
			return;
		}
		if (this.textPointer === 'instrumentText') {
			this.instrumentTextChange.emit(`${this.instrumentText} ${this.tag}`);
		}
		if (this.textPointer === 'requisitionText') {
			this.requisitionTextChange.emit(`${this.requisitionText} ${this.tag}`);
		}
	}

	private isChecked() {
		return this.regexPattern.test(this[this.textPointer]);
	}

	private setChecked() {
		const isChecked = this.isChecked();
		this.el.nativeElement.checked = isChecked;
		this.el.nativeElement.disabled = isChecked;
	}
}
